import React from 'react';
import { BlogPage } from './pages/BlogPage';
export function App() {
  return <BlogPage data-id="element-0" />;
}